import { apiSlice } from '../../api';
import type {
  GetProviderBalancesDTO,
  GetProviderBalancesResult,
  GetProviderLedgersDTO,
  GetProviderLedgersResult,
} from './types';

export const adminExchangeProviderEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getProviderBalances: build.query<GetProviderBalancesResult, GetProviderBalancesDTO>({
        query: ({ provider }) => ({
          url: `/admin/v1/providers/${provider}/balances`,
          method: 'GET',
        }),
      }),
      getProviderLedgers: build.query<GetProviderLedgersResult, GetProviderLedgersDTO>({
        query: ({ provider, params }) => ({
          url: `/admin/v1/providers/${provider}/ledgers`,
          method: 'GET',
          params,
        }),
      }),
    };
  },
});

export const { useGetProviderBalancesQuery, useLazyGetProviderBalancesQuery } =
  adminExchangeProviderEndpoints;

export const { useGetProviderLedgersQuery, useLazyGetProviderLedgersQuery } =
  adminExchangeProviderEndpoints;

export type AdminExchangeProviderController = typeof adminExchangeProviderEndpoints;
